
import { computed, defineComponent, watch } from 'vue';
import Carousel from 'primevue/carousel';
import { useRouter } from 'vue-router';
import AuthCompleteLayout from '@/views/layout/AuthCompleteLayout.vue';
import { buildNewsArticleUrl, useGleapNews } from '@/composables/useGleapNews';

export default defineComponent({
  name: 'LayoutAuthentication',

  components: {
    Carousel,
    AuthCompleteLayout,
  },

  setup() {
    const router = useRouter();
    const { news, loading: newsLoading, load: loadNews } = useGleapNews();

    const testimonials = [
      {
        title: 'Nous avons été séduits par sa facilité d\'utilisation et surtout par l\'accompagnement des équipes ShopiMind',
        image: '/images/logos-testimonials/archiduchesse.png',
        author: 'Pauline Calvo',
        position: 'Cheffe de projet E-commerce',
      },
      {
        title: 'Après un benchmark Shopimind semblait être la solution qui permettait de répondre à une grande partie de nos besoins',
        image: '/images/logos-testimonials/speedway.svg',
        author: 'Rodolphe Ricard',
        position: 'Responsable Acquisition',
      },
      {
        title: 'Une solution performante que nous utilisons depuis plusieurs années. L\'équipe est réactive et très sympathique (ce qui est très appréciable)',
        image: '/images/logos-testimonials/generationsouvenir.png',
        author: 'Sébastien Surget',
        position: 'Directeur',
      },
      {
        title: 'Très bon rapport qualité prix pour ce logiciel d\'abandon de panier omnicanal. Je recommande',
        image: '/images/logos-testimonials/beelong.svg',
        author: 'Benoit Delporte',
        position: 'Co-Fondateur',
      },
    ];

    const showLoginMode = computed(
      () => router.currentRoute.value.name !== 'user.registration-speed',
    );

    watch(() => router.currentRoute.value.name, (route) => {
      if (route !== 'user.registration-speed') {
        loadNews(9);
      }
    }, { immediate: true });

    return {
      testimonials,
      news,
      newsLoading,
      showLoginMode,
      buildNewsArticleUrl,
    };
  },
});
